export default {
  methods: {
    __activeModal(isActive, color) {
      if (!color) {
        color = '#f3ecde'
      }
      if (isActive !== true) {
        if (document.body) {
          document.body.style.backgroundColor = 'transparent'
        }
        if (document.documentElement) {
          document.documentElement.style.backgroundColor = 'transparent'
        }
      } else {
        if (document.body) {
          document.body.style.backgroundColor = color
        }
        if (document.documentElement) {
          document.documentElement.style.backgroundColor = color
        }
      }
    }
  },
  mounted: function() {
    this.__activeModal()
  },
  beforeDestroy: function() {
    this.__activeModal(false)
  }
}
